import { MetaReducer } from '@ngrx/store';
import { IAppState } from '../reducers/index.app.reducer';
import { hydrationMetaReducer } from './hydration.reducer';
import { clearStateMetaReducer } from './reset.reducer';

export const metaReducers: MetaReducer<IAppState>[] = [hydrationMetaReducer, clearStateMetaReducer];
